import { NavigationGuardNext, Route } from 'vue-router';
import AuthorityService from '@/domain/security/authority.service';
import Configuration from './configuration.view.vue';
import ServiceHooksConfiguration from './service-hooks-configuration/service-hooks-configuration.component.vue';
import ScriptsConfiguration from './scripts-configuration/scripts-configuration.component.vue';
import RuleGroupConfiguration from './scripts-configuration/rule-group-configuration.component.vue';
import RuleConfiguration from './rule-configuration/rule-configuration.component.vue';
import AccessionConfiguration from './accession-configuration/accession-configuration.component.vue';
import ProductTemplateDatatable from './product-template/product-template-datatable.component.vue';
import ReasonsCancellation from './reasons-cancellation/reasons-cancellation.component.vue';
import BusinessUnitSettingsConfiguration from './business-unit-settings-configuration/business-unit-settings-configuration.component.vue';

async function requireAccessAdministrator(
  _to: Route,
  _from: Route,
  next: NavigationGuardNext,
): Promise<void> {
  const authorities = await AuthorityService.authorities();
  if (authorities.includes('ACCESS_ADMINISTRATOR')) return next();
  return next('/access-denied');
}

export default [
  {
    path: '/configuration',
    component: Configuration,
    children: [
      {
        path: '',
        redirect: { name: 'ConfigurationServiceHooks' },
      },
      {
        path: 'service-hooks',
        name: 'ConfigurationServiceHooks',
        component: ServiceHooksConfiguration,
      },
      {
        path: 'calculos',
        name: 'ConfigurationScripts',
        component: ScriptsConfiguration,
      },
      {
        path: 'agrupamento-calculos',
        name: 'ConfigurationRuleGroup',
        component: RuleGroupConfiguration,
      },
      {
        path: 'nomenclaturas',
        name: 'ConfigurationRules',
        component: RuleConfiguration,
      },
      {
        path: 'liberar-acessos',
        name: 'ConfigurationAccession',
        component: AccessionConfiguration,
        beforeEnter: requireAccessAdministrator,
      },
      {
        path: 'padroes',
        name: 'ConfigurationProductTemplate',
        component: ProductTemplateDatatable,
      },
      {
        path: 'motivos-terceiro-nivel',
        name: 'ConfigurationReasons',
        component: ReasonsCancellation,
      },
      {
        path: 'configuracoes-unidade',
        name: 'ConfigurationBusinessUnitSettings',
        component: BusinessUnitSettingsConfiguration,
      },
    ],
  },
];
